import React, { useEffect, useState } from 'react';
import { TextField, Box } from '@mui/material';

import { convertToMilliseconds, convertToMonthsAndDays } from 'utilities/dates';

interface MonthDayInputProps {
    value: number;  // the current value in milliseconds
    error: boolean; // error state for the input
    onChange: (value: number) => void;
}

const MonthDayInput: React.FC<MonthDayInputProps> = ({ value, onChange, error = false }) => {
    const [months, setMonths] = useState<number | string>(''); // Treat months as string to handle empty case
    const [days, setDays] = useState<number | string>(''); // Treat days as string to handle empty case

    // Convert milliseconds to months and days when value changes
    useEffect(() => {
        const { months, days } = convertToMonthsAndDays(value);
        setMonths(months || '');  // Empty string for 0 value
        setDays(days || '');      // Empty string for 0 value
    }, [value]);

    // Handle month changes and convert back to milliseconds
    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newMonths = e.target.value === '' ? 0 : parseInt(e.target.value) || 0; // Treat empty as 0
        setMonths(newMonths === 0 ? '' : newMonths);
        const newMilliseconds = convertToMilliseconds(newMonths, days === '' ? 0 : parseInt(days.toString()));
        onChange(newMilliseconds);
    };

    // Handle day changes and convert back to milliseconds
    const handleDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newDays = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
        setDays(newDays === 0 ? '' : newDays);
        const newMilliseconds = convertToMilliseconds(months === '' ? 0 : parseInt(months.toString()), newDays);
        onChange(newMilliseconds);
    };

    return (
        <Box sx={{
            display: 'flex',
            gap: '5px',
            // alignItems: 'center',
            justifyContent: 'left',
            width: '100%'
        }}>
            <TextField
                label="თვე"
                value={months}
                onChange={handleMonthChange}
                size="small"
                type="number"
                inputProps={{ min: 0 }}
                error={error}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "&:focus": {
                            outline: '2px solid red',
                        },
                        "&:hover fieldset": {
                            color: "#1976d2",
                            borderColor: "#1976d2",
                            borderWidth: "2px",
                        },
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: "1rem",
                        top: '-2px',
                    },
                    shrink: true,
                }}
                InputProps={{
                    sx: {
                        height: '40px',
                        padding: '2px',
                    },
                    inputProps: {
                        fontSize: 10,
                        transition: "font-size 0.1s, color 0.2s",
                        min: 0,
                        style: {
                            fontSize: 12,
                        },
                        color: "rgba(0, 0, 0, 0.87)",
                        padding: "10px",
                    }
                }}
            />
            <TextField
                label="დღე"
                value={days}
                onChange={handleDayChange}
                size="small"
                type="number"
                inputProps={{ min: 0 }}
                error={error}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "&:focus": {
                            outline: '2px solid red',
                        },
                        "&:hover fieldset": {
                            color: "#1976d2",
                            borderColor: "#1976d2",
                            borderWidth: "2px",
                        },
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: "1rem",
                        top: '-2px',
                    },
                    shrink: true,
                }}
                InputProps={{
                    sx: {
                        height: '40px',
                        padding: '2px',
                    },
                    inputProps: {
                        fontSize: 10,
                        transition: "font-size 0.1s, color 0.2s",
                        min: 0,
                        style: {
                            fontSize: 12,
                        },
                        color: "rgba(0, 0, 0, 0.87)",
                        padding: "10px",
                    }
                }}
            />
        </Box>
    );
};

export default MonthDayInput;
